<template>
    <div class="event-card card-v2 tw-p-0">
        <router-link :to="{name: 'events.show', params: { event_slug: event.slug }}" class="card-full-img">
            <img :src="event.image" v-if="event.image">
        </router-link>
        <div class="card-inner">
            <div class="tw-flex tw-items-center">
                <div class="tw-pr-4">
                    <calendar-icon size="large" :tEvent="event"></calendar-icon>
                </div>
                <div class="tw-flex tw-flex-col tw-pb-5">
                    <router-link :to="{name: 'events.show', params: { event_slug: event.slug }}" class="hover:tw-underline">
                        <h3 class="tw-relative tw-text-normal tw-font-bold tw-leading-normal tw-mb-1">
                            {{ event.title }}
                            <span class="notification-count hidden notification-badge" :data-notify-id="'events.boards.' + event.slug"></span>
                        </h3>
                    </router-link>
                    <p class="tw-text-gray-500 tw-text-sm">
                        <i class="far fa-clock tw-mr-2"></i>
                        {{ formatedDateEvent }}
                    </p>
                    <!--
                    <p class="tw-text-gray-500" v-if="event.address !== ''">
                        <i class="far fa-map-marker-alt tw-mr-2"></i>
                        {{event.address }}
                    </p>-->
                    <p class="tw-text-gray-500 tw-text-sm" v-if="event.online">
                        <i class="far fa-globe tw-mr-2"></i>
                        {{ translations['events.online'].toLowerCase() }}
                    </p>
                </div>
            </div>
            <div class="tw-flex tw-flex-col tw-flex-1 tw-justify-between">
                <p v-line-clamp:30="3" class="description-clean tw-text-gray-500 tw-text-sm" v-text="event.description_clean"></p>
                <template v-if="event.category !== {}">
                    <category-pill :category="event.category" class="tw-mt-4"></category-pill>
                </template>
            </div>
            <div class="tw-flex tw-mt-4 tw-items-end">
                <div class="tw-flex tw-flex-1 tw-justify-between tw-items-center">
                    <div class="tw-flex tw-items-center tw-text-lg">
                           <div class="user-icon-previews event-members">
                            <template v-for="member in members">
                                <img :key="member.id" :src="member.user.avatar" onerror="this.src='/img/avatar.png'">
                            </template>
                            </div>
                            <span class="tw-ml-1 tw-font-bold tw-text-sm">{{ event.members_count }}</span>
                    </div>
                     <router-link class="general-button btn-v2" :to="{name: 'events.show', params: { event_slug: event.slug }}">
                        <span>{{ translations['events.singular'] }} {{ translations['groups.view'].toLowerCase() }}</span>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import CalendarIcon from './CalendarIcon.vue';
    import CategoryPill from './CategoryPill.vue';
    import Global from '../../mixins/Global';


    export default {
        name: 'EventCard',

        components: {
            'calendar-icon': CalendarIcon,
            'category-pill': CategoryPill,
        },

        mixins: [Global],

        props: {
            event: {
                required: true,
            },
        },

        data() {
            return {
                startdate: '',
                time: '',
            };
        },
        computed: {
            members() {
                return this.event.memberSelection.filter((member) => member.user != null);
            },

            formatedDateEvent() {
                const day = moment(this.event.start_date).format('DD');
                const weekday = moment.weekdaysMin(moment(this.event.start_date).day()).toLowerCase();
                const month = moment(this.event.start_date).format('MMM');
                const year = moment(this.event.start_date).format('YYYY');
                const timeEvent = moment(this.event.start_date).format('HH:mm');

                return `${weekday} ${day} ${month} ${year}, ${timeEvent}`;
            },
        },
    };
</script>

<style lang="scss">
    .event-card {
        .card-full-img {
            img {
                height: 130px;
            }
        }
    }
</style>
